import { render, staticRenderFns } from "./ProductTemplateList1.vue?vue&type=template&id=fd9040ce&scoped=true&"
import script from "./ProductTemplateList1.vue?vue&type=script&lang=js&"
export * from "./ProductTemplateList1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9040ce",
  null
  
)

export default component.exports